import { AdminFormRow } from '@ui';
import { memo } from 'react';
import { ControlledTextInput } from '@lp/features/admin/forms/components/inputs/ControlledTextInput';
import { ControlledPhoneInput } from '@lp/features/admin/forms/components/inputs/ControlledPhoneInput';
import { useFormContext, useWatch } from 'react-hook-form';
import { CreateOpoContactFormValues } from '@lp/features/admin/forms';

type MainOpoContactFormProps = {
  isReadOnly?: boolean;
};

export const MainOpoContactForm = memo(({ isReadOnly = false }: MainOpoContactFormProps) => {
  const { control } = useFormContext<CreateOpoContactFormValues>();

  const isOpoUser = useWatch({ control, name: 'isOpoUser' });
  const inviteAsUser = useWatch({ control, name: 'inviteAsUser' });
  const isNameRequired = isOpoUser || inviteAsUser;

  return (
    <>
      <AdminFormRow title="First Name" isRequired={isNameRequired}>
        <ControlledTextInput
          name="firstName"
          aria-label="Contact First Name"
          isReadOnly={isReadOnly}
          isDisabled={isReadOnly}
        />
      </AdminFormRow>
      <AdminFormRow title="Last Name" isRequired={isNameRequired}>
        <ControlledTextInput
          name="lastName"
          aria-label="Contact Last Name"
          isReadOnly={isReadOnly}
          isDisabled={isReadOnly}
        />
      </AdminFormRow>
      <AdminFormRow title="Primary Phone" inputWrapperClass="max-w-[20rem]" isRequired>
        <ControlledPhoneInput name="primaryPhone" disabled={isReadOnly} />
      </AdminFormRow>
      <AdminFormRow title="Secondary Phone" inputWrapperClass="max-w-[20rem]">
        <ControlledPhoneInput name="secondaryPhone" disabled={isReadOnly} />
      </AdminFormRow>
    </>
  );
});
